module.exports = __webpack_public_path__ + "static/media/friargate-3.bb1dc501.jpg";